import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const EquipmentPage = lazy(() => import('./EquipmentPage'));

const EquipmentPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/equipmenttypes',
         element: <EquipmentPage />,
      },
   ],
};

export default EquipmentPageConfig;
